import React, { useState } from 'react'
import { Helmet } from 'react-helmet'
import utils from '../../utils'
import SettingsSideBar from '../../components/settings/SettingsSideBar'
import AccountSettings from '../../components/settings/AccountSettings'
import PasswordSettings from '../../components/settings/PasswordSettings'

function SettingsPage(props) {
    const url = window.location.href
    const [currentTab, setCurrentTab] = useState(0)
    return (
        <div>
            <Helmet>
                <title>Settings - {utils.siteName}</title>
                <link rel="canonical" href={url} />
                <meta
                    property="description"
                    content="" />
            </Helmet>
            <div className="container mx-auto space-y-5">
                <div className="flex flex-col md:flex-row md:items-end justify-between gap-4">
                    <div>
                        <h1 className="text-3xl font-bold text-zinc-90 tracking-tight">Settings</h1>
                        <p className="text-zinc-500 mt-1">Manage your account and other app features.</p>
                    </div>
                </div>
                <div className='flex flex-col md:flex-row gap-4'>
                    <div className='md:w-3/12'>
                        <SettingsSideBar
                            currentTab={currentTab}
                            setCurrentTab={setCurrentTab}
                        />
                    </div>
                    <div className='md:w-9/12'>
                        {currentTab === 0 && (
                            <AccountSettings/>
                        )}
                        {currentTab === 1 && (
                            <PasswordSettings/>
                        )}
                    </div>
                </div>

            </div>

        </div>
    )
}

export default SettingsPage